import React, { useRef } from "react";
import { t } from "i18next";
import { EventsItem } from "@/types";
import { scrollToday } from "@/utils/agenda.ts";
import cn from "classnames";

export type EventHeading = {
  events: EventsItem[];
};
const CalendarHeading: React.FC<EventHeading> = () => {
  const ref = useRef(null);

  return (
    <div
      ref={ref}
      className={cn(
        "relative z-50 flex flex-col w-full box-border h-auto pointer-events-auto",
      )}
    >
      <div className="grid grid-cols-[calc(100%_-_81px)_81px] flex-row items-center justify-between">
        <div
          className={cn(
            "not-italic font-semibold text-2xl text-white capitalize items-center flex flex-row gap-4",
          )}
        >
          <p className="flex flex-row whitespace-nowrap" id="monthHeader"></p>
        </div>
        {/*<button*/}
        {/*  className={cn("block text-white mr-2", {*/}
        {/*    "rotate-180": show,*/}
        {/*  })}*/}
        {/*  onClick={() => {*/}
        {/*    setShowCalendar(!show);*/}
        {/*  }}*/}
        {/*>*/}
        {/*  <CaChevronDown />*/}
        {/*</button>*/}
        <button
          id="todayButton"
          className={cn(
            "min-w-[71px] max-w-fit h-[26px] bg-brand-secondary data-[alt=true]:bg-brand-light data-[alt=true]:text-brand  not-italic font-medium text-xs  flex items-center text-center text-white rounded",
            "flex items-center justify-center px-2 ",
          )}
          onClick={scrollToday}
        >
          {/* Today */}
          {t("agenda.today")}
        </button>
      </div>
      {/*<MiniCalendar events={events} show={show} />*/}
    </div>
  );
};
export default CalendarHeading;
